import React, {useState} from 'react'
import PropTypes from 'prop-types'
import {ModalContext} from './modalContext'
import {isEditing} from '@builder.io/sdk-react'
import {defaultModalTrigger, defaultModelContent} from './utils'

export const ModalContainer = ({children}) => {
    const isEdit = isEditing()
    const [modalOpen, setModalOpen] = useState(false)

    const enableModal = !isEdit
    return (
        <ModalContext.Provider
            value={{modalOpen, setModalOpen: enableModal ? setModalOpen : () => {}}}
        >
            {children}
        </ModalContext.Provider>
    )
}

ModalContainer.propTypes = {
    children: PropTypes.node
}

export const ModalContainerDefinition = {
    component: ModalContainer,
    name: 'Modal',
    noWrap: true,
    canHaveChildren: true,
    defaultChildren: [defaultModalTrigger, defaultModelContent]
}
